import React, { lazy } from 'react';
import { motion } from 'framer-motion';
interface ImageBreakerProps {
  src?: string;
  alt?: string;
}
/**
 * Full-bleed cinematic image band used to break between sections.
 * Edge-to-edge and image-led so the transition never feels flat.
 */
export function ImageBreaker({
  src = 'https://cdn.magicpatterns.com/uploads/5uhaouSEokhf1sswgQdatU/21.png',
  alt = 'Twilight exterior of 35 Campanilla, illuminated against the evening sky'
}: ImageBreakerProps) {
  return <section className="relative w-full h-[calc(70vh-200px)] min-h-[280px] md:h-[calc(100vh-200px)] overflow-hidden bg-primary z-10" data-id="element-104" data-mp="mmgio33682z8">
      <motion.div initial={{
      scale: 1.12
    }} whileInView={{
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1]
    }} className="absolute inset-0" data-id="element-105" data-mp="7wsix6an1cdm">
        <img src={src} alt={alt} loading="lazy" decoding="async" className="w-full h-full object-cover [image-rendering:auto]" data-id="element-106" data-mp="15esh4eqpek43" />
      </motion.div>
    </section>;
}